import React, { ChangeEvent, FC, useCallback, useState } from 'react'
import styles from 'styles/components/form.module.scss'
import image from 'styles/components/image.module.scss'
import { FlexRow } from 'components/Flex'
import { FormLabel } from 'components/Label'
import { Spacer } from 'components/Utility'
import { TextInput } from 'components/Form'
import { TaxHelpModal } from 'components/Modal'
import { PRODUCT_TAX_RATE } from 'constants/tax'

type Props = {
  handlePrice: (event: ChangeEvent<HTMLInputElement>) => void
  id: string
  isRequired?: boolean
  price: number
}

const PriceForm: FC<Props> = React.memo((props) => {
  const { handlePrice, id, isRequired = true, price } = props

  const [open, setOpen] = useState<boolean>(false)
  const openModal = useCallback(() => setOpen(true), [setOpen])
  const closeModal = useCallback(() => setOpen(false), [setOpen])

  return (
    <>
      <FlexRow justifyContent={'between'}>
        <FormLabel id={id} label={'販売単価(税抜)'} required={isRequired} />
        <img
          className={image.icon_clickable}
          src={'/icon/blue/help.svg'}
          alt={`販売単価に関するヘルプ`}
          onClick={openModal}
        />
      </FlexRow>
      <Spacer size={8} />
      <FlexRow justifyContent={'start'}>
        <TextInput
          disabled={false}
          maxWidth={96}
          onChange={handlePrice}
          required={isRequired}
          size={'small'}
          type={'tel'}
          value={price}
        />
        <Spacer size={8} />
        <div>
          <p className={styles.price__description}>アプリ上でお客さまに表示される金額</p>
          <p className={styles.price__value}>{Math.floor(price * PRODUCT_TAX_RATE)}円(税込)</p>
        </div>
      </FlexRow>
      <TaxHelpModal open={open} closeModal={closeModal} />
    </>
  )
})

export default PriceForm
